import { Badge, Card, CardContent, CardHeader, CardTitle } from "@nymbl/nos2-rules";
import { useSession } from "@/lib/auth-client";

function formatJoined(value: Date | string | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** Read-only summary of the signed-in user's account details. */
export function ProfileInfoCard() {
  const { data: session } = useSession();
  const user = session?.user;
  if (!user) return null;

  const fields: { label: string; value: React.ReactNode }[] = [
    { label: "Name", value: user.name || "—" },
    { label: "Email", value: user.email },
    {
      label: "Role",
      value: (
        <Badge variant={user.role === "admin" ? "default" : "secondary"} className="capitalize">
          {user.role ?? "user"}
        </Badge>
      ),
    },
    {
      label: "Email verified",
      value: user.emailVerified ? "Yes" : "No",
    },
    { label: "Member since", value: formatJoined(user.createdAt) },
  ];

  return (
    <Card className="border-border/50">
      <CardHeader>
        <CardTitle>Account details</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="divide-y divide-border/50">
          {fields.map((field) => (
            <div
              key={field.label}
              className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0"
            >
              <dt className="text-sm text-muted-foreground">{field.label}</dt>
              <dd className="text-sm font-medium">{field.value}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
